import type { CapabilitiesContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderCapabilities(caps: CapabilitiesContent): string {
  const cards = caps.items
    .map(
      (item, i) => `
      <div class="cap" data-reveal style="--i:${i}">
        <div class="idx">${String(i + 1).padStart(2, "0")}</div>
        <h3>${item.title}</h3>
        <p>${item.description}</p>
      </div>`,
    )
    .join("");

  return `
    <section class="section" id="${caps.id}">
      ${renderSectionHeader(caps.header)}
      <div class="caps">${cards}</div>
    </section>`;
}
